module.exports = __webpack_public_path__ + "media/12_35.3b821711.wav";